m = require 'mithril'

GameButton = {
	view: (ctrl, args) ->
		g = args.game
		navToGame = () -> m.route "/game/#{g.id}"
		m '.gamebutton', {onclick: navToGame}, [
			m '.gamebutton_name', {onclick: navToGame}, g.label
			m '.gamebutton_players', g.players.map((p) -> p.name).join ', '
			m '.gamebutton_date', g.date
		]
}

module.exports = GameButton